import React from 'react';

import { DatePickerContainerProps } from '@lyearn/ui';
import dynamic from '@/utils/dynamic';

const BaseInlineDatePicker = dynamic(
  () =>
    import(
      /* webpackChunkName: "inline-date-picker-ui" */
      './BaseInlineDatePicker'
    ),
);

const InlineDatePicker = (props: DatePickerContainerProps) => {
  return (
    <React.Suspense fallback={null}>
      <BaseInlineDatePicker {...props} />
    </React.Suspense>
  );
};

export default InlineDatePicker;
